/**
 * Component to render a responsive layout with two columns. Where the left
 * column displays a nav that is rendered to the left of the content at desktop
 * width, and above it at mobile width.
 */
import * as React from "react";

import {View} from "@khanacademy/wonder-blocks-core";
import {spacing} from "@khanacademy/wonder-blocks-tokens";
import {useResponsiveLayout} from "@khan/shared-styles";

type Props = {
    // The nav is rendered on the left-hand side at desktop width, and above
    // the content for mobile width.
    nav: React.ReactNode;
    content: React.ReactNode;
};

function ResponsiveTwoColumns({nav, content}: Props): React.ReactElement {
    const layout = useResponsiveLayout();

    return (
        <View
            style={
                layout === "desktop"
                    ? styles.desktopContainer
                    : styles.mobileContainer
            }
        >
            <View
                style={
                    layout === "desktop" ? styles.desktopNav : styles.mobileNav
                }
            >
                {nav}
            </View>
            <View style={styles.content}>{content}</View>
        </View>
    );
}

const styles = {
    desktopContainer: {
        flex: 1,
        flexDirection: "row",
    },

    mobileContainer: {
        flex: 1,
        flexDirection: "column",
    },

    desktopNav: {
        width: 270,
        padding: spacing.medium_16,
    },

    mobileNav: {
        flex: 1,
        padding: spacing.medium_16,
    },

    content: {
        flex: 1,
    },
} as const;

export default ResponsiveTwoColumns;
